import React from 'react';

function Objectives(props) {
    return (
        <div>
            <p>
                <b>Main Objective:</b> Develop a mobile application where cultivators can search for solutions by uploading images of diseases and other harmful pests in their crops and system gives a specified solution according to the issue.
            </p>
            <p>
                <b>Sub Objective 1:</b> Notify the cultivators, in case of a spread disease in their area, and inform the responsible authorities. <br/><br/>
                <b>Sub Objective 2:</b> Price forecasting for the vegetables according to the current market prices in three economical centers in Sri Lanka. GreenHubLK's market price forecasting feature can forecast a product's future price by evaluating data from the preceding year. <br/><br/>
                <b>Sub Objective 3:</b> Introducing the food banking concept for the cultivators to share their excess harvest. (Implement a method to get requirement priority of the people who get benefit from food banking.) <br/><br/>
                <b>Sub Objective 4:</b> Reduce the extra cost for the intermediate by introducing the direct buy and sell method for the cultivators based on their geographical locations and create an opportunity for cultivators to focus on the best market according to the demand for their crop. <br/><br/>
            </p>

        </div>
    );
}

export default Objectives;
